import { render } from "./FavoritesPopover.vue?vue&type=template&id=54186624"
import script from "./FavoritesPopover.vue?vue&type=script&lang=js"
export * from "./FavoritesPopover.vue?vue&type=script&lang=js"

import "./FavoritesPopover.vue?vue&type=style&index=0&id=54186624&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__